import { FadeIn } from '~/components/ui/fade-in';
import { ProductDesktopAccordion } from '~/components/ui/ProductDesktopAccordion';

interface AccordionItem {
  title: string;
  description: string;
}

interface PlatformService {
  title: string;
  description: string;
  image: string;
  accordionItems: AccordionItem[];
}

interface JadePlatformSectionProps {
  eyebrow: string;
  headingLines: string[];
  services: PlatformService[];
}

export const JadePlatformSection = ({
  eyebrow,
  headingLines,
  services,
}: JadePlatformSectionProps) => {
  return (
    <section className="bg-neutral-1 px-4 md:px-20 py-[60px] md:py-[120px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col gap-5 text-black">
          <FadeIn>
            <p className="font-['Fragment_Mono','Fragment_Mono_Fallback',monospace] text-sm tracking-[0.14px] uppercase">
              {eyebrow}
            </p>
          </FadeIn>
          <FadeIn delay={0.15}>
            <div className="font-['Manrope','Manrope_Fallback',sans-serif] font-medium text-[24px] md:text-[40px]">
              {headingLines.map((line) => (
                <p key={line}>{line}</p>
              ))}
            </div>
          </FadeIn>
        </div>

        <div className="mt-12 md:mt-20 flex flex-col gap-12 md:gap-20">
          {services.map((service, index) => (
            <div
              key={`${service.title}-${index}`}
              className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 md:gap-10"
            >
              <div className="w-full md:w-[680px] h-[214px] md:h-[425px] overflow-hidden bg-black/5">
                <img
                  src={service.image}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col gap-4 md:gap-[15px] md:w-[564px] text-black">
                <FadeIn>
                  <div>
                    <p className="font-['Manrope','Manrope_Fallback',sans-serif] text-[20px] md:text-[30px] leading-[1.4]">
                      {service.title}
                    </p>
                    <p className="mt-3 font-['Manrope','Manrope_Fallback',sans-serif] text-sm md:text-base leading-[1.5] tracking-[0.16px]">
                      {service.description}
                    </p>
                  </div>
                </FadeIn>

                <ProductDesktopAccordion
                  items={service.accordionItems}
                  idPrefix={`jade-service-${index}`}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
